import { Descope } from '@descope/react-sdk';

function WrappedFlow(props) {
    const { flowId, theme, borderRounded, baseURL, bgColorHex, validateOnBlur, styleId , flowWidth} = props;
    const flowStyle = {};
    if (bgColorHex) {
      flowStyle["background-color"] = "#"+bgColorHex;
    }
    if (flowWidth) {
      flowStyle["width"] = flowWidth+"px";
    }
    return (
      <div className={borderRounded ? 'page flow-shown': "page flow-shown rounded-top"} style={flowStyle}  >
          <Descope
            flowId={flowId}
            baseURL={baseURL}
            theme={theme}
            styleId={styleId}
            validateOnBlur={String(validateOnBlur)}
          />
      </div>
    )
  }

  export default WrappedFlow;